import React from 'react';

import {Button, Input} from 'antd';

import { FormattedMessage, useIntl } from "react-intl";

import {openNotificationWithIcon} from '../../../Utility/notificationMessage';

import {sendNotificationAfterAddedChangeVideo} from '../functions';

const SettingLesson = (props) => {
    const {setInputValue, inputValue, setVideoIdCode, setLoading, deleteLesson, changeTitle, state, lists} = props;
    const { activeListKey } = state;
    const activeList = lists.filter(item => item.id === state.activeListKey )[0];
    const intl = useIntl();

    const getVideo = () => {
        setLoading(true);
        if(inputValue){
          const url = inputValue.split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
          setTimeout(() => {
            setVideoIdCode((url[2] !== undefined) ? url[2].split(/[^0-9a-z_\-]/i)[0] : url[0]);
            setInputValue('');
            setLoading(false);
            sendNotificationAfterAddedChangeVideo(activeListKey, activeList.title);
          }, 1000)
        }else{
          openNotificationWithIcon('warning', intl.formatMessage({id:'Paste the code or link', defaultMessage: 'Paste the code or link'}));
          setInputValue('');
          setLoading(false);
        }
    } 

    return(
        <div className="setting_lesson">
                <div className="add_video_layout">
                    <Input 
                        placeholder={intl.formatMessage({id: 'YouTube video - embedd code or link', defaultMessage: 'YouTube video - embedd code or link'})}
                        onChange={(e) => setInputValue(e.target.value)}
                        value={inputValue}
                    />
                    <Button
                        type="primary"
                        onClick={() => getVideo()}
                        className="add_video_btn"
                    >
                        <span>
                            <FormattedMessage id="Upload" defaultMessage="Upload"/>
                        </span>
                    </Button>
                </div>
                <Button
                    type="primary"
                    onClick={() => changeTitle()}
                >
                    <span>
                        <FormattedMessage id="Change title" defaultMessage="Change title"/>
                    </span>
                </Button>
                <Button
                    type="primary"
                    onClick={() => {deleteLesson()}}
                >
                    <span>
                        <FormattedMessage id="Delete" defaultMessage="Delete"/>
                    </span>
                </Button> 
        </div>
    )
}









export default SettingLesson;